// state.api.fileView
export const getCopyParams = state => state.api.fileView.copyParams;
export const getFileViewFields = state => state.ui.fileView.fields;
export const getFileViewOpenNodes = state => state.api.fileView.openedNodes;
export const getRefetchFiles = state => state.api.fileView.refetchFiles;
export const getSelectedResources = state => state.api.fileView.selectedResources;

// state.api.folder
export const getSelectedFolder = state => state.api.folder.data;
export const getSelectedFolderId = state => state.api.folder.data.folderId;

// state.ui.siteFolders
export const getFoldersForShareFileModal = state => state.api.siteFolders?.folders || [];
